import { MoneyCollectOutlined } from '@ant-design/icons';
import CardWithIcon from 'components/new-ui/base/card/CardWithIcon';
import { TaxLine } from 'store/invoices/types';
import TaxLinesTable from './TaxLinesTable';

type Props = {
    taxLines: TaxLine[];
};

const LiabilitySection = ({ taxLines }: Props) => {
    return (
        <CardWithIcon
            gap="medium"
            layout="vertical"
            title="Liability"
            iconProps={{
                size: 32,
                borderRadius: 8,
                icon: <MoneyCollectOutlined />,
                status: 'success',
            }}
            children={
                <>
                    <TaxLinesTable taxLines={taxLines} />
                </>
            }
        />
    );
};

export default LiabilitySection;
